import { FC, memo, PropsWithChildren, ReactNode } from 'react'
import Header from './Header'
import Meta from './Meta'

export interface IHeaderLayout {
  title?: ReactNode
  subTitle?: ReactNode
  actions?: ReactNode
}

export type IPage = {
  header?: IHeaderLayout
  footer?: ReactNode
}

const Page: FC<PropsWithChildren<IPage>> = ({ children, header }) => {
  const MetaLazy = memo(() => <Meta title={String(header?.title || '')} />)
  return (
    <>
      <MetaLazy />
      <div className='px-4 sm:px-6 lg:px-8 flex flex-col gap-5'>
        {!!header && Object.values(header).find(Boolean) && <Header {...header} />}
        {children}
      </div>
    </>
  )
}

export default Page
